import React from "react";
import JoLedger from "../accounting/JoLedger";

const EmployeeJoLedger = () => (
  <JoLedger
    portalLabel="Employee Portal"
    pageTitle="JO Ledger"
    pageDescription="Track the job orders you created and follow their request and liquidation progress."
    scope="created"
    hideCostAnalysis
    hideVouchers
    hideBilled
    hideGrossProfit
    basePath="/admin/jo-ledger"
  />
);

export default EmployeeJoLedger;
